export default __webpack_public_path__ + "static/media/img-trabajo-10.467f5f82.jpg";